// extracted by mini-css-extract-plugin
export default {"container":"SendOrder_container__zuQJW","row":"SendOrder_row__-dxXL","buttonWrapper":"SendOrder_buttonWrapper__7-i40","column":"SendOrder_column__tpQsb","sum":"SendOrder_sum__gerZ5"};